module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Sections</span></div>\r\n<div class=\"row prop-detail\"> \r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel\">&nbsp;</label> \r\n            <div>\r\n                <select name=\"section\" id=\"section\">\r\n                    <option value=\"complete\">Complete</option>\r\n                    <option value=\"form\">App Pages Only</option>\r\n                    <option value=\"appendix\">Appendix Only</option>\r\n                        <option value=\"separate\">Complete, but separated</option>\r\n                </select>\r\n            </div>\r\n        </div>   \r\n    </div>\r\n</div>")
  }
  return __output;

}